import React, { useEffect, useRef, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
// @ts-ignore: no def file
import { useHistory } from 'react-router-dom';
import { ReactComponent as CopyIcon } from '../../../../assets/images/copy.svg';
import { Event } from '../../../../dorian-shared/types/event/Event';
import { api } from '../../../api';
import { showToast } from '../../../ui/utils';
import { DetailedPrize } from '../components/EventForm/DetailedPrizes/DetailedPrizeType';

export function DuplicateButton({ eventId }: { eventId: number }) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => () => {
    mountedRef.current = false;
  }, []);

  const handleDuplicateClick = () => {
    setIsLoading(true);
    Promise.all([
      api.get<{ event: Event }>(`/v1/events/${eventId}`),
      api.get<{ prizes: DetailedPrize[] }>(`/v1/events/${eventId}/prizes`),
    ])
      .then(([eventResponse, prizesResponse]) => {
        if (!mountedRef.current) return;
        history.push('/events/new', {
          duplicateEvent: eventResponse.data.event,
          duplicatePrizes: prizesResponse.data.prizes,
        });
      })
      .catch(() => {
        if (!mountedRef.current) return;
        showToast({
          textMessage: 'There was an issue when duplicating your event, please try again later or contact support.',
          timeout: 20000,
        });
        setIsLoading(false);
      });
  };

  return (
    <Button
      onClick={handleDuplicateClick}
      variant="secondary"
      size="sm"
      className="mx-1"
      disabled={isLoading}
      title="Duplicate"
    >
      {isLoading ? (
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
      ) : (
        <CopyIcon className="btnImg" />
      )}
    </Button>
  );
}
